/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteRoutePlansParams,
  GetRoutePlansParams,
  PatchRoutePlansParams,
  PostRoutePlansParams,
  PostgrestError,
  RoutePlans,
  RoutePlansInsertPayload,
  RoutePlansUpdate
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getRoutePlansResponse200 = {
  data: RoutePlans[]
  status: 200
}

export type getRoutePlansResponse206 = {
  data: RoutePlans[]
  status: 206
}

export type getRoutePlansResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getRoutePlansResponseSuccess = (getRoutePlansResponse200 | getRoutePlansResponse206) & {
  headers: Headers;
};
export type getRoutePlansResponseError = (getRoutePlansResponseDefault) & {
  headers: Headers;
};

export type getRoutePlansResponse = (getRoutePlansResponseSuccess | getRoutePlansResponseError)

export const getGetRoutePlansUrl = (params?: GetRoutePlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/route_plans?${stringifiedParams}` : `${backendBaseUrl}/route_plans`
}

/**
 * @summary Read rows from `route_plans`.
 */
export const getRoutePlans = async (params?: GetRoutePlansParams, options?: RequestInit): Promise<getRoutePlansResponse> => {

  const res = await fetch(getGetRoutePlansUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getRoutePlansResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getRoutePlansResponse
}


export type postRoutePlansResponse201 = {
  data: RoutePlans[]
  status: 201
}

export type postRoutePlansResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postRoutePlansResponseSuccess = (postRoutePlansResponse201) & {
  headers: Headers;
};
export type postRoutePlansResponseError = (postRoutePlansResponseDefault) & {
  headers: Headers;
};

export type postRoutePlansResponse = (postRoutePlansResponseSuccess | postRoutePlansResponseError)

export const getPostRoutePlansUrl = (params?: PostRoutePlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/route_plans?${stringifiedParams}` : `${backendBaseUrl}/route_plans`
}

/**
 * @summary Insert one or more rows into `route_plans`.
 */
export const postRoutePlans = async (routePlansInsertPayload: RoutePlansInsertPayload,
    params?: PostRoutePlansParams, options?: RequestInit): Promise<postRoutePlansResponse> => {

  const res = await fetch(getPostRoutePlansUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(routePlansInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postRoutePlansResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postRoutePlansResponse
}


export type patchRoutePlansResponse200 = {
  data: RoutePlans[]
  status: 200
}

export type patchRoutePlansResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchRoutePlansResponseSuccess = (patchRoutePlansResponse200) & {
  headers: Headers;
};
export type patchRoutePlansResponseError = (patchRoutePlansResponseDefault) & {
  headers: Headers;
};

export type patchRoutePlansResponse = (patchRoutePlansResponseSuccess | patchRoutePlansResponseError)

export const getPatchRoutePlansUrl = (params?: PatchRoutePlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/route_plans?${stringifiedParams}` : `${backendBaseUrl}/route_plans`
}

/**
 * @summary Update the rows of `route_plans` matching the given filters.
 */
export const patchRoutePlans = async (routePlansUpdate: RoutePlansUpdate,
    params?: PatchRoutePlansParams, options?: RequestInit): Promise<patchRoutePlansResponse> => {

  const res = await fetch(getPatchRoutePlansUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(routePlansUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchRoutePlansResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchRoutePlansResponse
}


export type deleteRoutePlansResponse200 = {
  data: RoutePlans[]
  status: 200
}

export type deleteRoutePlansResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteRoutePlansResponseSuccess = (deleteRoutePlansResponse200) & {
  headers: Headers;
};
export type deleteRoutePlansResponseError = (deleteRoutePlansResponseDefault) & {
  headers: Headers;
};

export type deleteRoutePlansResponse = (deleteRoutePlansResponseSuccess | deleteRoutePlansResponseError)

export const getDeleteRoutePlansUrl = (params?: DeleteRoutePlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/route_plans?${stringifiedParams}` : `${backendBaseUrl}/route_plans`
}

/**
 * @summary Delete the rows of `route_plans` matching the given filters.
 */
export const deleteRoutePlans = async (params?: DeleteRoutePlansParams, options?: RequestInit): Promise<deleteRoutePlansResponse> => {

  const res = await fetch(getDeleteRoutePlansUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteRoutePlansResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteRoutePlansResponse
}


